;(function ($, window) {
  'use strict'

  // setup a shared namespace, if needed
  window.GCO = window.GCO || {}

  window.GCO.sliders = (function () {
    function setupSlick () {
      $('.slick').slick({
        dots: false,
        infinite: true,
        speed: 300,
        centerMode: true,
        variableWidth: true,
        centerPadding: '60px',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        XmobileFirst: true, // for responsive breakpoints
        Xresponsive: [
          {
            breakpoint: 1024,
            settings: {
              centerMode: false,
              centerPadding: '40px',
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 3
            }
          }
        ]
      })
    }

    function init () {
      const $slick = $('.slick')
      if ($slick.length > 0) {
        setupSlick()
      }
    }

    return {
      init: init
    }
  }())

  $(document).ready(function () {
    GCO.sliders.init()
  })
}(jQuery, window))
